import { Request as JSONRequest } from "../helpers/request";

class LiquidityPositionController extends JSONRequest {
  constructor() {
    super({ url: import.meta.env.VITE_BACKEND_API_URL });
  }

  /**
   * Positions of a wallet with a balance, each with its pair and tokens; one request per 500 positions
   */
  getUserPositions(userId) {
    return this.getAllPages(`/v2/users/${userId}/positions`);
  }
}

export let liquidityPosition = new LiquidityPositionController();
